import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { ContentLabelField, DatePicker } from '@hopskipdrive/react-components';
import { parseISO } from 'date-fns';
import * as Yup from 'yup';

interface IncidentDateFieldProps {
  defaultValue?: string;
}

export const incidentDateValidation = Yup.date()
  .min(new Date(1999, 0, 1), 'Invalid date')
  .test('max', 'Date cannot be in the future', (value) => {
    const endOfDay = new Date(new Date().setHours(23, 59, 59, 999));

    return !!value && value <= endOfDay;
  })
  .typeError('Invalid date')
  .required('Incident date is required');

export const IncidentDateField = ({ defaultValue }: IncidentDateFieldProps): ReactElement => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: 'incidentDate',
    control,
    defaultValue: defaultValue ? parseISO(defaultValue) : null,
  });

  return (
    <ContentLabelField
      id="incidentDate"
      title="Incident on"
      editMode={true}
      required={true}
      editView={
        <DatePicker
          onChange={field.onChange}
          value={field.value || null}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!fieldState.error,
              helperText: fieldState.error?.message,
              inputProps: {
                'data-testid': 'incidentDate',
              },
            },
          }}
        />
      }
    />
  );
};
